import { registerGlobalListeners } from '~/signalr-events'

export default function (context) {
  context.$signalR.on('open', () => {
    registerGlobalListeners(context.$signalR.onEvent, context)
  })
}
